import { createContext, useState, useContext, useCallback, useMemo } from 'react';
import { getCurrentAddress } from '../../utils/getAddress';
import { AddressContextValue, AddressProviderProps } from './types/propTypes';

const AddressContext = createContext<AddressContextValue>({
  address: '',
  shippingType: '',
  addressToDisplay: '',
  postalCodeToDisplay: '',
  updateAddress: () => {
    /* do nothing */
  },
});

export function AddressProvider(props: AddressProviderProps) {
  const [currentAddress, setCurrentAddress] = useState(props.initialAddress);
  const [shippingType, setShippingType] = useState(props.initialShippingType);
  const [postalCodeToDisplay, setPostalCodeToDisplay] = useState(props.initialPostalCodeToDisplay);
  const [addressToDisplay, setAddressToDisplay] = useState(props.initialAddressToDisplay);
  const updateAddress = useCallback(() => {
    const { currentAddress, shippingType, addressToDisplay, postalCodeToDisplay } = getCurrentAddress();
    setAddressToDisplay(addressToDisplay);
    setPostalCodeToDisplay(postalCodeToDisplay);
    setCurrentAddress(currentAddress);
    setShippingType(shippingType);
  }, []);
  const value = useMemo(
    () => ({
      address: currentAddress,
      shippingType: shippingType,
      addressToDisplay: addressToDisplay,
      postalCodeToDisplay: postalCodeToDisplay,
      updateAddress: updateAddress,
    }),
    [currentAddress, updateAddress, shippingType, addressToDisplay, postalCodeToDisplay],
  );
  return <AddressContext.Provider value={value}>{props.children}</AddressContext.Provider>;
}

export function useAddress() {
  const { address, shippingType, addressToDisplay, postalCodeToDisplay }: AddressContextValue =
    useContext(AddressContext);
  return { address, shippingType, addressToDisplay, postalCodeToDisplay };
}

export function useAddressUpdate() {
  const { updateAddress }: AddressContextValue = useContext(AddressContext);
  return { updateAddress };
}

export { getCurrentAddress };
